module.exports = __webpack_public_path__ + "img/oursolution5.cded20ab.png";